import React from 'react';
import PropTypes from 'prop-types';
import GenericNavList from './GenericNavList';
import style from '../../../scss/components/MainNavigation';
import logo from '../../../img/logo.jpeg';
import enLangLogo from '../../../img/globe.svg';
import cnLangLogo from '../../../img/globe.svg';
import geLangLogo from '../../../img/globe.svg';
import SpLangLogo from '../../../img/globe.svg';
import ImageBlock from '../ImageBlock';
import qrTop from '../../../img/QR_TOP.jpg';

export default class DesktopNavigation extends React.Component {

  constructor(props) {
    super(props);
    this.state = { searchOpen: false, menuOpen: false, langMenuOpen: false };
    this.searchInputRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  static propTypes = {
    mainMenuItems: PropTypes.array,
    contact_page_url: PropTypes.string,
    search_page_url: PropTypes.string
  }

  static defaultProps = {
    mainMenuItems: []
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.node && !this.node.contains(event.target)) {
      this.showSearch(false);
    }
  }
  toggleMenu() {
    let isMenuOpen = this.state.menuOpen;
    this.setState({ menuOpen: !isMenuOpen });
  }
  showSearch(flag) {
    var self = this;
    this.setState({ searchOpen: flag }, () => {
      window.setTimeout(function () { self.searchInputRef.current.focus(); }, 100);
    });
  }
  toggleSearch() {
    var self = this;
    let isSearchOpen = self.state.searchOpen;
    this.setState({ searchOpen: !isSearchOpen }, () => {
      window.setTimeout(function () { self.searchInputRef.current.focus(); }, 100);
    });
  }
  performSearch() {
    if (this.state.query)
      window.location = this.props.search_page_url + "?query=" + this.state.query;
  }
  handleSearchClick = () => {
    if (this.state.menuOpen)
      this.performSearch();
    else
      this.showSearch(true);
  }
  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.performSearch();
    }
  }
  getImageProp = () => {
    let img = {};
    img.url = logo;
    return img;
  }
  getEnLangImageProp = () => {
    let img = {};
    img.url = enLangLogo;
    return img;
  }

  getEsLangImageProp = () => {
    let img = {};
    img.url = SpLangLogo;
    return img;
  }

  getCnLangImageProp = () => {
    let img = {};
    img.url = cnLangLogo;
    return img;
  }
  getGerLangImageProp = () => {
    let img = {};
    img.url = geLangLogo;
    return img;
  }
  togglelangMenu_en() {
    location.href = "https://www.hunterlab.com/en"+window.location.pathname;
  }
  togglelangMenu_enuk() {
    location.href = "https://www.hunterlab.com/en-uk"+window.location.pathname;
  }
  togglelangMenu_es() {
    location.href = "https://www.hunterlab.com/es"+window.location.pathname;
  }
  togglelangMenu_Germany(){
    location.href = "https://www.hunterlab.de";
  }
  toggleMenuList() {
    let isLangMenuOpen = this.state.langMenuOpen;
    this.setState({ langMenuOpen: !isLangMenuOpen });
  }
  render() {
    return (
      <section className="navbar">

        <div className="container">
          <div className="navbar-inner">
            <div className="navbar-left">
              <a
                className="navbar-logo"
                href="/">
                <ImageBlock image={this.getImageProp()} addWrapper={false}></ImageBlock>
              </a>
              <button className={"sm-menu-lang-view" + (this.state.menuOpen ? " close" : " ")} onClick={() => this.toggleMenuList()} >
                <ImageBlock image={this.getCnLangImageProp()} addWrapper={false}></ImageBlock>
                <div className={"sm-menu-lang-list"+ (this.state.langMenuOpen && !(this.state.menuOpen) ? " open" : " close")} >
                  <ul>
                  <li class="menu-li-lang">
                    <a href="#" onClick={() => this.togglelangMenu_en()}>
                    <ImageBlock image={this.getEnLangImageProp()} addWrapper={false}></ImageBlock>
                      <span className="lang-txt-sm">English</span>
                    </a>
                    </li>
                    <li class="menu-li-lang">
                    <a href="#" onClick={() => this.togglelangMenu_Germany()}>
                    <ImageBlock image={this.getGerLangImageProp()} addWrapper={false}></ImageBlock>
                      <span className="lang-txt-sm">Deutsch</span>
                    </a>
                  </li>
                  <li class="menu-li-lang">
                    <a href="#" onClick={() => this.togglelangMenu_es()}>
                    <ImageBlock image={this.getEsLangImageProp()} addWrapper={false}></ImageBlock>
                      <span className="lang-txt-sm">Español</span>
                    </a>
                  </li>
                  <li class="menu-li-lang">
                    <a href="#" onClick={() => this.togglelangMenu_enuk()}>
                    <ImageBlock image={this.getEnLangImageProp()} addWrapper={false}></ImageBlock>
                      <span className="lang-txt-sm">UK English</span>
                    </a>
                  </li>
                  </ul>
                </div>
              </button>
              <button className={"toggle-btn" + (this.state.menuOpen ? " open" : "")} onClick={() => this.toggleMenu()}></button>
            </div>
            <nav className={"navbar-right" + (this.state.searchOpen ? " active" : "") + (this.state.menuOpen ? " open" : "")}>
            <div class="img-style">
                <div class="qrnav">
                  <div class="img-nav"></div> 
                  <div class="img-title">官方公众号</div>
                  <div class="qrhover"><img src={qrTop} alt="" width="200px" /></div>
                </div>
              </div>
              <GenericNavList
                prefix="navbar-nav"
                items={this.props.mainMenuItems} showDesc={true}>
                <li className="nav-btn"><a href={this.props.contact_page_url} className="btn btn-outline-contact">联系我们</a></li>
                <li className=" has-menu menu-lang-selector">
                  <button>
                    <ImageBlock image={this.getCnLangImageProp()} addWrapper={false}></ImageBlock>
                    <div className="sub-nav mega-menu">
                    <div className="mega-menu-right">
                      <ul className="menu">                        
                      <li class="menu-li-lang">
                          <a href="#" onClick={() => this.togglelangMenu_en()}>
                          <ImageBlock image={this.getEnLangImageProp()} addWrapper={false}></ImageBlock>
                            <span className="lang-txt">English</span>
                          </a>
                        </li>
                        <li class="menu-li-lang">
                          <a href="#" onClick={() => this.togglelangMenu_Germany()}>
                          <ImageBlock image={this.getGerLangImageProp()} addWrapper={false}></ImageBlock>
                              <span className="lang-txt">Deutsch</span>
                            </a>
                          </li>
                          <li class="menu-li-lang">
                          <a href="#" onClick={() => this.togglelangMenu_es()}>
                          <ImageBlock image={this.getEsLangImageProp()} addWrapper={false}></ImageBlock>
                            <span className="lang-txt">Español</span>
                          </a>
                        </li>
                        <li class="menu-li-lang">
                          <a href="#" onClick={() => this.togglelangMenu_enuk()}>
                            <ImageBlock image={this.getEnLangImageProp()} addWrapper={false}></ImageBlock>
                            <span className="lang-txt">UK English</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  </button>
                </li>
              </GenericNavList>
              <form className="nav-search-form" ref={node => this.node = node}>
                <div className="form-group has-icon">
                  <input ref={this.searchInputRef} type="text" className="form-control" placeholder="搜索关键词..."
                    onChange={event => { this.setState({ query: event.target.value }) }}
                    onKeyPress={this.handleKeyPress} />
                  <a onClick={() => this.toggleSearch()} className="form-icon icon-search"></a>
                </div>
              </form>
            </nav>
          </div>

        </div>

      </section>
    )
  }

}